export const getTopColour = (stylesParam: string | undefined): string => {
  if (!stylesParam) {
    return "white";
  }

  const styles = stylesParam.split(" ");

  if (styles.includes("terracotta")) {
    return "terracotta";
  } else if (styles.includes("beige")) {
    return "beige";
  } else if (styles.includes("sky")) {
    return "sky";
  }

  return "white";
};

export const getRoundedTop = (stylesParam: string | undefined): boolean => {
  if (!stylesParam) {
    return false;
  }

  const styles = stylesParam.split(" ");

  return styles.includes("top");
};
